import * as MuiIcons from "@mui/icons-material";
import * as Mui from "@mui/material";
import { useContext } from "react";
import { customTheme } from "../../../../../../config/theme/MuiTheme";
import { ContextOperation } from "../../../../context/OperationContext";
import useOperationTranslation from "../../../../hooks/useOperationTranslation";
import useSnackbar from "../../../../hooks/useSnackbar";
import TransferReasonService from "../../TransferReasonService";
import { TransferReasonTypes } from "../../Types";

interface Props {
    open: boolean;
    onClose: () => void;
    onApproveTender: () => void;
    carrier?: TransferReasonTypes.ICarrierTender;
    requestId?: number;
}

const ApproveConfirmation = (props: Props) => {
    const { tenant } = useContext(ContextOperation);

    const snackbar = useSnackbar();

    const t = useOperationTranslation();

    const onApproveTender = () => {
        if (!props.carrier) return;

        if (!props.requestId) {
            snackbar.show("warning", t("transferReason.manageCarriers.warningSnackBarSecond"));
            return;
        }

        const tenderDetails: TransferReasonTypes.TenderDetails = {
            priceStartValidityDate: props.carrier.startValidity,
            priceEndValidityDate: props.carrier.endValidity,
            priceStartProvince: props.carrier.provinceStartCode,
            priceEndProvince: props.carrier.provinceEndCode,
            priceKmRangeFrom: props.carrier.kmFrom,
            priceKmRangeTo: props.carrier.kmTo,
            priceLoadIndex: props.carrier.loadIndex,
            carrierAddress: props.carrier.carrierAddress || "Via qualsiasi",
            carrierCity: props.carrier.carrierCity || "Milano",
            carrierName: props.carrier.carrierName,
            priceIncreasePercentage: props.carrier.variation,
            priceIncreaseStartDate: props.carrier.variationDateFrom,
            priceIncreaseEndDate: props.carrier.variationDateTo,
            finalPrice: props.carrier.finalPrice,
            price: props.carrier.basePrice,
            priceType: props.carrier.type,
            carrierBpCode: props.carrier.supplierBpCode,
        }

        TransferReasonService.put.approveTender(tenant, props.requestId, tenderDetails).then(
            () => {
                props.onClose();
                props.onApproveTender();
                snackbar.show("success", t("transferReason.manageCarriers.requestSnackBarChosen"));
            },
            () => {
                props.onClose();
                snackbar.show("error", t("transferReason.manageCarriers.errorSnackBarSecond"));
            }
        )
    }

    return(
        <>
            <Mui.Dialog open={props.open} onClose={props.onClose} fullWidth={true} maxWidth="sm">
                <Mui.DialogTitle>
                    <Mui.Grid container alignItems="center">
                        <Mui.Grid item xs="auto">
                            <Mui.Grid container spacing={1}>
                                <Mui.Grid item xs="auto" color={customTheme.palette.accent.main}>
                                    <MuiIcons.Info color="inherit" />
                                </Mui.Grid>
                                
                                <Mui.Grid item xs="auto">
                                    <Mui.Typography>
                                        {t("transferReason.manageCarriers.approveCarrier")}
                                    </Mui.Typography>
                                </Mui.Grid>
                            </Mui.Grid>
                        </Mui.Grid>

                        <Mui.Grid item xs="auto" marginLeft="auto">
                            <Mui.IconButton onClick={props.onClose}>
                                <MuiIcons.Close />
                            </Mui.IconButton>
                        </Mui.Grid>
                    </Mui.Grid>
                </Mui.DialogTitle>

                <Mui.DialogContent>
                    <Mui.Typography>
                        {t("transferReason.manageCarriers.messagePopupSecond").replace("#textElement", props.carrier?.carrierName || "")}
                    </Mui.Typography>
                </Mui.DialogContent>

                <Mui.DialogActions>
                    <Mui.Grid item>
                        <Mui.Button variant="outlined" size="smallPlus" onClick={props.onClose}>
                            {t("transferReason.manageCarriers.cancelButton")}
                        </Mui.Button>
                    </Mui.Grid>
                    <Mui.Grid item>
                        <Mui.Button size="smallPlus" onClick={onApproveTender}>
                            {t("transferReason.manageCarriers.approveButton")}
                        </Mui.Button>
                    </Mui.Grid>
                </Mui.DialogActions>
            </Mui.Dialog>
        </>
    )
}
export default ApproveConfirmation;